<div class="container">
  <div class="columns is-centered">
    <div class="column is-6 mt-4 box has-background-link-light">
      <h1 class="title">About</h1>
      <div class="box">
        <p class="mb-3">
          This application provides you a currency converter that uses the
          latest rates.
        </p>
        <p>
          <b>Powered by: </b>
          <a href="https://exchangeratesapi.io/" target="_blank"
            >https://exchangeratesapi.io/</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
